import { convertIGuideHtmlToLatex } from '../ast/util.html-to-latex.js';

function convertInputToLatex(input, entry, args) {
  const entryValue = entry?.answers[args.taskId]?.[input.id] ?? "";
  const answerValue = entryValue || input.predefinedAnswer || "";
  const heading = input.text ? convertIGuideHtmlToLatex(input.text) : undefined;
  const answer = answerValue ? convertIGuideHtmlToLatex(answerValue) : undefined;
  return [heading, answer].filter(it => !!it);
}

export { convertInputToLatex };
//# sourceMappingURL=atom.input.js.map
